import { fetchAuthSession } from "aws-amplify/auth";
import { type AuthStateType } from "@/components/global_variables/global";

export async function getDynamicAuthMode(): Promise<AuthStateType> {
  try {
    // This checks the current session and auto-refreshes tokens if possible
    const session = await fetchAuthSession();
    
    // If we have valid tokens, the user is still actively authenticated
    if (session.tokens?.accessToken) {
      return "userPool";
    }
    
    // If no tokens, they are a guest/expired
    return "identityPool";
  } catch (error) {
    // If fetchAuthSession throws an error (e.g., no session found), default to guest
    return "identityPool";
  }
}